export const defaultPagination = {
  currentPage: 1,
  pageSize: 25,
  totalCount: 0
};
